function getNetworkConnection() {
  if (!import.meta.client || !navigator.connection) {
    return undefined
  }

  return {
    downlink: navigator.connection.downlink,
    downlinkMax: navigator.connection.downlinkMax,
    effectiveType: navigator.connection.effectiveType,
    rtt: navigator.connection.rtt,
    saveData: navigator.connection.saveData,
    type: navigator.connection.type,
  }
}

async function dynamicImport(importFn: () => Promise<any>, moduleName: string) {
  try {
    return await importFn()
  } catch (error) {
    const { getSentry } = await import('@myfunnow/web-core/sentry')
    const sentry = getSentry()

    // Record which file failed to load for better error tracking
    sentry?.captureMessage('Module load failed', {
      level: 'info',
      extra: {
        error,
        moduleName,
        isSsr: import.meta.server,
        networkConnection: getNetworkConnection(),
      },
    })

    throw error
  }
}

export default dynamicImport
